import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema as gridScreenSchema } from './MarketingPlanningGrid/schemas';
import {
  formScreenSchema,
  previewScreenSchema,
} from './MarketingPlanningWizard/schemas';

export const marketingPlanningBaseLink = new Link('marketing-planning');

export const marketingPlanningGridScreenSchema = new SearchParams(
  gridScreenSchema
);

export const marketingPlanningGridLink = marketingPlanningBaseLink.child(
  '/',
  marketingPlanningGridScreenSchema
);

export const marketingPlanningPreviewScreenSchema = new SearchParams(
  previewScreenSchema
);

export const marketingPlanningPreviewLink = marketingPlanningBaseLink.child(
  ':year/:month',
  marketingPlanningPreviewScreenSchema
);

export const marketingPlanningWizardScreenSchema = new SearchParams(
  formScreenSchema
);

export const marketingPlanningWizardLink = marketingPlanningBaseLink.child(
  'edit/:year/:month',
  marketingPlanningWizardScreenSchema
);

export const marketingPlanningWizardLevelsLink =
  marketingPlanningWizardLink.child(
    ':networkId?/:applicationId?/:channelId?/:platformId?/:affiliateId?/:countryId?/:managerId?'
  );
